import { Component } from '@angular/core';
import { LegalLinksContainerComponent } from '../../../../shared/components/legal-links-container/legal-links-container.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-invalid-invitation',
  imports: [LegalLinksContainerComponent, TranslocoDirective, RouterModule],
  templateUrl: './invalid-invitation.component.html',
  styleUrl: './invalid-invitation.component.css'
})
export class InvalidInvitationComponent {}
